import axios from "axios";
import { getErrorRes, getSuccessRes } from "../helpers/api-response";
import { handleErrorMessage } from "../helpers/handle-error-message";
import logger from "../helpers/logger";
import { API_BASE_URL } from "../config/api-config";
import axiosIns from "../common/interceptor/axios-interceptor";

// Use the configured API base URL instead of environment variable

//Formula
//Fetch Formula data
export const fetchFormulaData = async (noCache = false) => {
  try {
    const res = await axiosIns.get(
      `rackstar/formula?noCache=${noCache}`
    );
    return getSuccessRes(res.data || [], "Formula data fetched successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Formula data.`);
  }
};

// Update an existing Formula entry
export const updateFormulaData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/formula/${id}`,
      data
    );
    return getSuccessRes(res.data, "Formula data updated successfully!");
  } catch (error) {
    logger.error("updateFormulaData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Formula Data.");
  }
};

//Add a Formula data
export const addFormulaData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(`rackstar/formula`, data);
    return getSuccessRes(res.data, "Formula data added successfully!");
  } catch (error) {
    logger.error("addFormulaData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add Formula data.");
  }
};

//Fetch Bid Terminal Group data
export const fetchBidTerminalGroupData = async () => {
  try {
    const res = await axiosIns.get(
      `rackstar/bidterminalgroup`
    );
    return getSuccessRes(
      res.data || [],
      "Bid terminal group data fetched successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error);
    throw getErrorRes(errMessage, `Failed to fetch bid terminal group data.`);
  }
};

//Formula Low Map
//Fetch Formula Low Map data
export const fetchFormulaLowMapData = async () => {
  try {
    const res = await axiosIns.get(`rackstar/formulalowmap`);
    return getSuccessRes(
      res.data || [],
      "Formula Low Map data fetched successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Formula Low Map data.`);
  }
};

//Delete Formula Low Map
export const deleteFormulaLowMapData = async (id) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/formulalowmap/${id}`
    );
    return getSuccessRes(
      res.data || [],
      "Formula Low Map data deleted successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete Formula Low Map data.`);
  }
};

// Update an existing Formula Low Map entry
export const updateFormulaLowMapData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/formulalowmap/${id}`,
      data
    );
    return getSuccessRes(
      res.data,
      "Formula Low Map data updated successfully!"
    );
  } catch (error) {
    logger.error("updateFormulaLowMapData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Formula Low Map Data.");
  }
};

//Add a Formula Low Map data
export const addFormulaLowMapData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/formulalowmap`,
      data
    );
    return getSuccessRes(res.data, "Formula Low Map data added successfully!");
  } catch (error) {
    logger.error("addFormulaLowMapData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add Formula Low Map data.");
  }
};

//Variables
//Fetch Variables data
export const fetchVariablesData = async () => {
  try {
    const res = await axiosIns.get(
      `rackstar/formulafuelproductmap`
    );
    return getSuccessRes(
      res.data || [],
      "Variables data fetched successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Variables data.`);
  }
};

//Delete Variable
export const deleteVariableData = async (id) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/formulafuelproductmap/${id}`
    );
    return getSuccessRes(res.data || [], "Variable data deleted successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete Variable data.`);
  }
};

// Update an existing Variable entry
export const updateVariableData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/formulafuelproductmap/${id}`,
      data
    );
    return getSuccessRes(res.data, "Variable data updated successfully!");
  } catch (error) {
    logger.error("updateVariableData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Variable Data.");
  }
};

// Export alias for consistency (singular/plural naming)
export const updateVariablesData = updateVariableData;

//Add a Variable data
export const addVariableData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/formulafuelproductmap`,
      data
    );
    return getSuccessRes(res.data, "Variable data added successfully!");
  } catch (error) {
    logger.error("addVariableData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add Variable data.");
  }
};

// Export alias for consistency (singular/plural naming)
export const addVariablesData = addVariableData;

//Delete Variables
export const deleteVariablesData = async (id, toastId) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/formulafuelproductmap/${id}`
    );
    return getSuccessRes(res.data, "Variables data deleted successfully!");
  } catch (error) {
    logger.error("deleteVariablesData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to delete Variables data.");
  }
};

//Fetch Formula MM market data
export const fetchFormulaMMData = async () => {
  try {
    const res = await axiosIns.get(
      `rackstar/formulamarketmap`
    );
    return getSuccessRes(
      res.data || [],
      "Formula market map data fetched successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error);
    throw getErrorRes(errMessage, `Failed to fetch formula market map data.`);
  }
};

//Validate Formula calculation
export const validateFormulaCalculation = async (formulaCalculation, inputDate) => {
  try {
    const res = await axiosIns.post(
      `rackstar/formula/validate`,
      {
        FormulaCalculation: formulaCalculation,
        InputDate: inputDate
      }
    );
    return getSuccessRes(res.data, "Formula validation completed successfully.");
  } catch (error) {
    logger.error("validateFormulaCalculation", error);
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, "Failed to validate formula calculation.");
  }
};